import { createContext, ReactNode, useState } from "react";
import { useLocalStorage } from "./useLocalStorage";

type User = {
    id: string;
    expires: string;
};

type Props = {
    children?: ReactNode;
};

type IAuthContext = {
    user?: User;
    setUser: (user: User) => void;
};

const AuthContext = createContext<IAuthContext>(null!);

const AuthProvider = ({ children }: Props) => {
    //Initializing an auth state with false value (unauthenticated)
    const { getItem, setItem, removeItem } = useLocalStorage();
    let optionalUser = getItem("user");
    if (optionalUser) {
        const u: User = JSON.parse(optionalUser);
        const cookieDate = new Date(u.expires);
        const currentData = new Date();
        const expired = cookieDate.getTime() < currentData.getTime();
        if (expired) {
            removeItem("user");
            optionalUser = undefined;
        }
    }

    const [user, updateUser] = useState<User>(optionalUser && JSON.parse(optionalUser));

    const setUser = (user: User) => {
        updateUser(user);
        setItem("user", JSON.stringify(user));
    };

    return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
